const images = {
  //   commonImgAuthBackground: require('./common_img_auth_background.png'),
  imgStatisticOne: require('./img_statistic_one.png'),
  imgStatisticTwo: require('./img_statistic_two.png'),
  imgEmail: require('./img_email.png'),
  imgCall: require('./img_call.png'),
  imgLogo: require('./img_logo.png'),
  imgDefaultInventory: require('./img_default_inventory.jpg'),
};

export default images;
